import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const GridIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-428 -252)" },
            React.createElement("g", { transform: "translate(428 252)" },
                React.createElement("path", { d: "M4.662,13.321h4c3.33,0,4.662-1.332,4.662-4.662v-4C13.321,1.332,11.989,0,8.659,0h-4C1.332,0,0,1.332,0,4.662v4C0,11.989,1.332,13.321,4.662,13.321Z", transform: "translate(1.339 1.339)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0H13.3", transform: "translate(1.36 5.667)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0H13.3", transform: "translate(1.36 10.333)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,13.308V0", transform: "translate(5.673 1.346)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,13.308V0", transform: "translate(10.34 1.346)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })))));
};
export default GridIcon;
//# sourceMappingURL=GridIcon.js.map